/* ==========================================================================
   TNF category browsing 1.1.1                                    2026-09-24
   Products inside a category load themselves as the customer approaches the
   end of what is on screen, batch after batch, until the whole collection is
   on the page - no "Show More" button in normal browsing. The server's own
   pagination stays underneath: its next-page link is what this script
   follows in the collection's own order, and it is what a browser without
   JavaScript (and a search engine) still gets.

   1.2.0 (final brief, 24 Sep 2026): when the price order cannot be built after its retries, the Sort control and
   the address go back to the collection's own order (the page never claims a price order it does not show) and
   the status line offers "Try again"; designs whose card shows no amount sort after every priced card.
   1.1.1 (Brief 7 checks, 24 Sep 2026): the price order's two look-ups (the
   price index and the card renderer) try again twice (after 1.2 s and 3.5 s)
   when the shop answers "too busy" (408, 429, 5xx) or the connection drops,
   before falling back to the collection's own order. A busy moment no longer
   leaves "Price: low to high" in Shopify's order.

   1.1.0 (Brief 6, 24 Sep 2026):
   - PRICE ORDER = THE PRICE THE CARD SHOWS. "Price: low to high / high to low"
     (the Sort control above the grid, or ?sort_by=price-ascending|descending)
     sorts the COMPLETE matching collection by the market price each card
     displays - the engine price of the minimum configuration for catalogue
     designs, the cheapest real variant otherwise (templates/collection.
     tnf-index.liquid reads the same badge snippet the card renders) - and
     then loads that order batch after batch with the theme's own card
     (templates/search.tnf-cards.liquid). Shopify's own price sort (variant
     minimum in the shop currency) is only the no-JavaScript fallback.
   - BACK RESTORES even when the loaded cards could not be kept (no storage,
     or more than the storage limit): the same batches are loaded again in
     order and the scroll position is put back afterwards. (1.0.0 read the
     request token before load() advanced it, so the replay stopped after the
     first batch.)
   - A SORT (or any re-render of the grid) STARTS AGAIN CLEANLY: the request
     in flight is aborted and its answer ignored, and the totals, the next
     link / sorted list, the storage key (the address changes), the
     de-duplication set and the observers are all rebuilt for the new grid.
   - a failed batch keeps every card and offers Retry, which asks for the same
     batch again (never skips one, never duplicates one).
   Unchanged from 1.0.0: next batch requested ~1.5 screens before the end;
   no duplicates; custom-order products, tests and charging helpers never
   shown; small status line (role=status) instead of the button; "Skip to the
   end of the results" link; keyboard focus never moved; the retired
   all-products listing is not a product grid, so nothing here runs there.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__tnfBrowseLoaded) return; window.__tnfBrowseLoaded = true;   /* loaded by the sort control AND the pagination snippet */
  var grid = document.getElementById('CollectionProductGrid'); if (!grid) return;
  var list = grid.querySelector('.productListing'); if (!list) return;
  var sortForm = document.querySelector('form[data-tnf-sort]');
  var IS_COLLECTION = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[^/]+/i.test(location.pathname);
  if (!grid.querySelector('[data-tnf-browse]') && !sortForm) return;      /* one page and no sort control: nothing to do */
  var SKIP_HANDLE = /^\/?(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections\/[^/]+\/)?products\/(custom-neon-|zz-internal-test)/i;
  var SKIP_H = /^(custom-neon-|zz-internal-test)/i;
  var STORE_MAX = 2 * 1024 * 1024, STORE_TTL = 45 * 60 * 1000;
  var st = { mode: 'server', next: null, done: false, loading: false, ctrl: null, token: 0, pages: 1, seen: {}, failed: false,
             total: 0, items: null, count: 0, per: 20, dir: null, key: '', io: null, initial: 0 };

  function $(s, r) { return (r || grid).querySelector(s); }
  function meta() { return grid.querySelector('[data-tnf-browse]'); }
  function nextLink() { return $('.pagination-page-infinite a[data-infinite-scrolling][href]'); }
  function readNext() { if (st.mode !== 'server') return; var a = nextLink(); st.next = a ? a.getAttribute('href') : null; st.done = !st.next; }
  function cards(root) { return Array.prototype.slice.call((root || list).querySelectorAll(':scope > li.product')); }
  function idOf(li) { var pi = li.querySelector('.product-item[data-product-id]'); if (pi) return pi.getAttribute('data-product-id'); var a = li.querySelector('a[href*="/products/"]'); return a ? a.getAttribute('href') : null; }
  function shown() { return cards().filter(function (li) { return !li.classList.contains('banner'); }).length; }
  function remember(root) { cards(root).forEach(function (li) { var id = idOf(li); if (id) st.seen[id] = 1; }); }
  function params() { var u = new URLSearchParams(location.search); ['page', 'view', 'preview_theme_id', '_pos', '_sid', '_ss'].forEach(function (k) { u.delete(k); }); return u; }
  function keyNow() { var u = params(); u.sort && u.sort(); var q = u.toString(); return 'tnf-browse:' + location.pathname + (q ? '?' + q : ''); }
  function sortNow() { return new URLSearchParams(location.search).get('sort_by') || ''; }
  function isPriceSort(v) { return IS_COLLECTION && (v === 'price-ascending' || v === 'price-descending'); }

  /* ---- status line (replaces the Show More button while JS runs) ------- */
  var status = document.createElement('div');
  status.className = 'tnf-browse-status'; status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
  var sentinel = document.createElement('div'); sentinel.className = 'tnf-browse-sentinel'; sentinel.setAttribute('aria-hidden', 'true');
  var skip = document.createElement('a'); skip.className = 'tnf-browse-skip'; skip.href = '#shopify-section-footer'; skip.textContent = 'Skip to the end of the results';
  skip.addEventListener('click', function (e) { var f = document.getElementById('shopify-section-footer') || document.querySelector('footer'); if (f) { e.preventDefault(); f.setAttribute('tabindex', '-1'); f.scrollIntoView({ block: 'start' }); f.focus({ preventScroll: true }); } });
  var tail = null;                                    /* where the status line lives when the grid has no pagination block */
  function mount() {
    var wrap = $('.pagination-wrapper') || $('.pagination');
    if (!wrap) {
      if (!tail) { tail = document.createElement('div'); tail.className = 'pagination-wrapper tnf-browse-tail'; }
      if (!tail.parentNode) list.parentNode.insertBefore(tail, list.nextSibling);
      wrap = tail;
    }
    if (sentinel.parentNode !== wrap.parentNode || sentinel.nextSibling !== wrap) wrap.parentNode.insertBefore(sentinel, wrap);
    if (status.parentNode !== wrap) { wrap.appendChild(status); wrap.appendChild(skip); }
    grid.classList.add('tnf-browse-on');
  }
  function setStatus(kind, text, withRetry) {
    status.className = 'tnf-browse-status is-' + kind;
    status.innerHTML = '';
    if (kind === 'loading') { var sp = document.createElement('span'); sp.className = 'tnf-browse-spinner'; sp.setAttribute('aria-hidden', 'true'); status.appendChild(sp); }
    var t = document.createElement('span'); t.className = 'tnf-browse-text'; t.textContent = text; status.appendChild(t);
    if (withRetry) { var b = document.createElement('button'); b.type = 'button'; b.className = 'tnf-browse-retry'; b.textContent = 'Retry'; b.addEventListener('click', function () { nextBatch(true); }); status.appendChild(b); }
  }
  function counter() {
    /* the theme's "Showing 1 - N of M" line: N = what is on the page, M = what there is to show */
    var s = $('[data-total-start]'), e = $('[data-total-end]'), n = shown();
    if (s) s.textContent = n ? '1' : '0'; if (e) e.textContent = String(n);
    var tot = $('.pagination-page-total'); if (tot && st.total) tot.querySelectorAll('span').forEach(function (sp) { if (/of\s+\d+/.test(sp.textContent)) sp.textContent = sp.textContent.replace(/of\s+\d+/, 'of ' + st.total); });
    var bar = $('.pagination-total-item'); if (bar && st.total) bar.style.width = Math.min(100, Math.round(100 * n / st.total)) + '%';
    return n;
  }
  function announce() {
    var n = counter();
    if (st.done) setStatus('done', st.total ? 'All ' + st.total + ' products shown' : 'All products shown');
    else setStatus('idle', st.total ? 'Showing ' + n + ' of ' + st.total + ' products' : 'Showing ' + n + ' products');
  }

  /* ---- one batch, whatever the order --------------------------------------
     Every batch carries the token current when it started; reset() moves the token on, so an answer that
     arrives after a sort change (or any re-render) is dropped, and its request is aborted anyway. */
  function append(nodes) {
    var added = 0, frag = document.createDocumentFragment();
    nodes.forEach(function (li) {
      if (li.classList.contains('banner')) return;
      var link = li.querySelector('a[href*="/products/"]'); if (link && SKIP_HANDLE.test(link.getAttribute('href') || '')) return;
      var id = idOf(li); if (id && st.seen[id]) return; if (id) st.seen[id] = 1;
      li.setAttribute('data-tnf-loaded', '1');
      frag.appendChild(li); added++;
    });
    list.appendChild(frag);
    return added;
  }
  function fetchServer(tok) {
    var url = st.next;
    return fetch(url, { credentials: 'same-origin', signal: st.ctrl ? st.ctrl.signal : undefined, headers: { 'X-Requested-With': 'tnf-browse' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        if (tok !== st.token || !list.isConnected) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ng = doc.getElementById('CollectionProductGrid'); var nl = ng && ng.querySelector('.productListing');
        if (!nl) throw new Error('no grid in the response');
        var added = append(cards(nl).map(function (li) { return document.adoptNode(li); }));
        var np = ng.querySelector('.pagination'), cp = $('.pagination');
        if (np && cp) cp.replaceWith(document.adoptNode(np));
        st.pages++; mount(); readNext();
        return added;
      });
  }
  /* the theme's own card for exactly these products, placed in the sorted order */
  /* 1.1.1: a look-up the price order depends on tries again when the shop is busy (408 / 429 / 5xx) or the
     connection drops - twice, after 1.2 s and 3.5 s - and never after an abort or an ordinary 4xx */
  function fetchRetry(url, opts, kind, tries) {
    tries = tries == null ? 2 : tries;
    return fetch(url, opts).then(function (r) {
      if (r.ok) return r;
      var e = new Error(kind + ' HTTP ' + r.status); e.status = r.status; throw e;
    }).catch(function (err) {
      if ((err && err.name === 'AbortError') || tries <= 0) throw err;
      if (err && err.status && err.status !== 408 && err.status !== 429 && err.status < 500) throw err;
      return new Promise(function (res) { setTimeout(res, tries === 2 ? 1200 : 3500); }).then(function () {
        if (opts && opts.signal && opts.signal.aborted) { var a = new Error('aborted'); a.name = 'AbortError'; throw a; }
        return fetchRetry(url, opts, kind, tries - 1);
      });
    });
  }
  function renderCards(slice, signal) {
    var ids = slice.map(function (i) { return i[4]; }).filter(Boolean);
    var url = '/search?view=tnf-cards&type=product&q=' + encodeURIComponent(ids.map(function (id) { return 'id:' + id; }).join(' OR '));
    return fetchRetry(url, { credentials: 'same-origin', signal: signal, headers: { 'X-Requested-With': 'tnf-browse' } }, 'cards')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString('<div id="tnf-wrap">' + html + '</div>', 'text/html');
        var byHandle = {};
        Array.prototype.slice.call(doc.querySelectorAll('#tnf-wrap > .product')).forEach(function (c) { if (c.getAttribute('data-handle')) byHandle[c.getAttribute('data-handle')] = c; });
        var out = [], missing = [];
        slice.forEach(function (it) {
          var c = byHandle[it[0]]; if (!c) { missing.push(it[0]); return; }
          var li = document.createElement('li'); li.className = 'product'; li.innerHTML = c.innerHTML;
          /* the renderer is the search template: its search-tracking parameters are removed from the links */
          li.querySelectorAll('a[href*="_sid="], a[href*="_pos="], a[href*="_ss="]').forEach(function (a) { try { var u = new URL(a.getAttribute('href'), location.origin); ['_pos', '_sid', '_ss', '_psq'].forEach(function (k) { u.searchParams.delete(k); }); a.setAttribute('href', u.pathname + (u.searchParams.toString() ? '?' + u.searchParams.toString() : '') + u.hash); } catch (e) {} });
          out.push(li);
        });
        return { nodes: out, missing: missing };
      });
  }
  function fetchSlice(tok) {
    var slice = st.items.slice(st.count, st.count + st.per);
    return renderCards(slice, st.ctrl ? st.ctrl.signal : undefined).then(function (res) {
      if (tok !== st.token || !list.isConnected) return null;
      /* a product the renderer could not return is taken out of the list, so the total always counts cards that exist */
      if (res.missing.length) { st.items = st.items.filter(function (i) { return res.missing.indexOf(i[0]) < 0; }); st.total = st.items.length; }
      var added = append(res.nodes);
      st.count = Math.min(st.items.length, st.count + slice.length - res.missing.length);
      st.pages++; st.done = st.count >= st.items.length;
      return added;
    });
  }
  function nextBatch(manual) {
    if (st.loading || st.done) return Promise.resolve(false);
    if (st.failed && !manual) return Promise.resolve(false);
    if (st.mode === 'server' && !st.next) { st.done = true; announce(); return Promise.resolve(false); }
    var more = st.mode === 'server' ? nextLink() : null;
    if (more && more.hasAttribute('data-tnf-sorted-more')) {    /* a template whose own toolbar owns its sorted listing */
      if (!more.classList.contains('is-loading')) more.click();
      return Promise.resolve(false);
    }
    var tok = st.token;
    st.loading = true; st.failed = false;
    st.ctrl = window.AbortController ? new AbortController() : null;
    setStatus('loading', 'Loading more products…');
    var p = st.mode === 'sorted' ? fetchSlice(tok) : fetchServer(tok);
    return p.then(function (added) {
      if (tok !== st.token || added === null) return false;
      st.loading = false;
      afterAppend(added);
      announce(); save();
      if (!st.done) setTimeout(check, 50);                     /* the sentinel may still be in view */
      return true;
    }, function (err) {
      if (tok !== st.token || (err && err.name === 'AbortError')) return false;
      st.loading = false; st.failed = true;
      setStatus('error', 'Couldn’t load more products.', true);
      return false;
    });
  }
  function afterAppend(added) {
    try {
      var sf = window.sharedFunctions || {};
      if (sf.checkNeedToConvertCurrency && sf.checkNeedToConvertCurrency() && window.Currency && window.jQuery) Currency.convertAll(window.shop_currency, jQuery('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
      if (window.wishlist && window.wishlist.show && sf.setLocalStorageProductForWishlist) sf.setLocalStorageProductForWishlist();
      if (typeof window.initColorSwatchCards === 'function') window.initColorSwatchCards(list);
    } catch (e) {}
    try { if (window.TNF_PROMO_API && window.TNF_PROMO_API.run) window.TNF_PROMO_API.run(list); } catch (e) {}
    document.dispatchEvent(new CustomEvent('tnf:browse:appended', { detail: { added: added, shown: shown(), mode: st.mode } }));
  }
  function check() {
    if (st.done || st.loading || st.failed) return;
    var r = sentinel.getBoundingClientRect();
    if (r.top < (window.innerHeight || 800) * 2.5) nextBatch(false);
  }

  /* ---- starting again: the grid now shows something else -------------------
     Called for a sort change, a Back/Forward between sort orders, and when anything else replaces the
     grid. Aborts the batch in flight, moves the token on (its answer is ignored), and rebuilds the
     totals, next link / sorted list, storage key, de-duplication set and observers for the new grid. */
  function reset(mode) {
    if (st.ctrl) { try { st.ctrl.abort(); } catch (e) {} }
    st.token++; st.loading = false; st.failed = false; st.pages = 1; st.seen = {}; st.mode = mode || 'server'; st.dir = null;
    st.items = null; st.count = 0; st.next = null; st.done = false;
    st.key = keyNow();
    var m = meta();
    st.total = m ? (parseInt(m.getAttribute('data-total'), 10) || 0) : shown();
    st.per = m ? (parseInt(m.getAttribute('data-page-size'), 10) || 20) : 20;
    remember(); readNext(); mount(); bindObservers();
    st.initial = cards().length;
  }
  function bindObservers() {
    if (st.io) st.io.disconnect();
    if (window.IntersectionObserver) {
      st.io = new IntersectionObserver(function (entries) { if (entries.some(function (en) { return en.isIntersecting; })) nextBatch(false); }, { rootMargin: '1500px 0px 1500px 0px' });
      st.io.observe(sentinel);
    }
  }
  /* anything else that replaces the product list (the theme's own toolbar on other templates) */
  if (window.MutationObserver) new MutationObserver(function () {
    var nl = grid.querySelector('.productListing');
    if (nl && nl !== list) { list = nl; reset('server'); if (isPriceSort(sortNow()) && sortForm) enterSorted(sortNow(), false); else announce(); setTimeout(check, 100); }
    else if (!sentinel.isConnected || !status.isConnected) mount();
  }).observe(grid, { childList: true, subtree: true });

  /* ---- displayed-price order ------------------------------------------------ */
  function indexUrl(n) {
    var u = params(); u.delete('sort_by'); u.set('view', 'tnf-index'); u.set('page', String(n));
    return location.pathname + '?' + u.toString();
  }
  function fetchIndex(signal) {
    var get = function (n) { return fetchRetry(indexUrl(n), { credentials: 'same-origin', signal: signal }, 'index').then(function (r) { return r.json(); }); };
    return get(1).then(function (first) {
      var pages = Math.max(1, first.pages | 0), rest = [];
      for (var n = 2; n <= pages; n++) rest.push(get(n));
      return Promise.all(rest).then(function (others) { return [first].concat(others); });
    }).then(function (all) {
      var items = [];
      all.forEach(function (pd) { (pd.items || []).forEach(function (it) { if (!SKIP_H.test(it[0])) items.push(it); }); });
      var seen = {}; items = items.filter(function (it) { if (seen[it[4]]) return false; seen[it[4]] = 1; return true; });
      return items;
    });
  }
  function sortItems(items, dir) {
    var asc = dir === 'price-ascending';
    return items.slice().sort(function (a, b) {
      /* 1.2.0: a design whose card shows no amount ("Price to be confirmed") follows every priced card, in both
         directions - the order never claims a price for it */
      var na = a[1] == null || !isFinite(a[1]), nb = b[1] == null || !isFinite(b[1]);
      if (na !== nb) return na ? 1 : -1;
      return (na ? 0 : (asc ? a[1] - b[1] : b[1] - a[1])) || String(a[2]).localeCompare(String(b[2])) || (a[4] - b[4]);
    });
  }
  /* enter the price order: the index for exactly this grid (same path, same filters), sorted by the price
     each card shows, then the first batch replaces the server's cards in one swap */
  function enterSorted(dir, fromRestore, saved) {
    reset('sorted'); st.dir = dir;
    var tok = st.token;
    st.loading = true; st.ctrl = window.AbortController ? new AbortController() : null;
    grid.classList.add('tnf-browse-sorting');
    setStatus('loading', 'Sorting by price…');
    var itemsP = saved && saved.items && saved.items.length ? Promise.resolve(saved.items) : fetchIndex(st.ctrl ? st.ctrl.signal : undefined).then(function (it) { return sortItems(it, dir); });
    return itemsP.then(function (items) {
      if (tok !== st.token) return;
      st.items = items; st.total = items.length;
      if (saved && saved.html) {
        var tmp = document.createElement('ul'); tmp.innerHTML = saved.html;
        list.innerHTML = ''; st.seen = {};
        var added = append(Array.prototype.slice.call(tmp.children));
        st.count = Math.min(items.length, saved.count || added); st.pages = Math.max(1, Math.ceil(st.count / st.per));
        st.done = st.count >= items.length; st.loading = false;
        grid.classList.remove('tnf-browse-sorting'); afterAppend(added); announce();
        return 'restored';
      }
      var first = items.slice(0, st.per);
      return renderCards(first, st.ctrl ? st.ctrl.signal : undefined).then(function (res) {
        if (tok !== st.token) return;
        if (res.missing.length) { st.items = st.items.filter(function (i) { return res.missing.indexOf(i[0]) < 0; }); st.total = st.items.length; }
        list.innerHTML = ''; st.seen = {};
        var added = append(res.nodes);
        st.count = Math.min(st.items.length, first.length - res.missing.length); st.pages = 1;
        st.done = st.count >= st.items.length; st.loading = false;
        grid.classList.remove('tnf-browse-sorting');
        afterAppend(added); announce(); save();
        if (!st.done) setTimeout(check, 50);
        return 'sorted';
      });
    }).catch(function (err) {
      if (tok !== st.token || (err && err.name === 'AbortError')) return;
      /* the price order could not be built (after its retries): Shopify's own order stays on screen, the server
         batches continue - and 1.2.0 (final brief) the page no longer CLAIMS a price order it is not showing: the
         Sort control and the address go back to the collection's own order, and the status line says so with a
         Retry that asks for the price order again */
      grid.classList.remove('tnf-browse-sorting');
      if (window.console) console.warn('[tnf-browse] price order unavailable, the collection order is kept.', err);
      var def = sortForm ? (sortForm.getAttribute('data-default') || '') : '';
      var sel = sortForm && sortForm.querySelector('select'); if (sel) sel.value = def;
      try { var u0 = new URLSearchParams(location.search); u0.delete('sort_by'); history.replaceState(history.state, '', location.pathname + (u0.toString() ? '?' + u0.toString() : '')); } catch (e) {}
      reset('server'); announce();
      status.className = 'tnf-browse-status is-error';
      status.innerHTML = '';
      var t0 = document.createElement('span'); t0.className = 'tnf-browse-text'; t0.textContent = 'Sorting by price isn\u2019t available right now \u2013 showing the usual order.'; status.appendChild(t0);
      var b0 = document.createElement('button'); b0.type = 'button'; b0.className = 'tnf-browse-retry'; b0.textContent = 'Try again';
      b0.addEventListener('click', function () { applySort(dir, true); }); status.appendChild(b0);
    });
  }
  /* the Sort control: in place, with the address updated (Back / Forward step through the orders) */
  function applySort(value, push) {
    var def = sortForm ? (sortForm.getAttribute('data-default') || '') : '';
    var u = new URLSearchParams(location.search); u.delete('page');
    if (!value || value === def) u.delete('sort_by'); else u.set('sort_by', value);
    var url = location.pathname + (u.toString() ? '?' + u.toString() : '');
    if (push) { try { history.pushState({ tnfSort: value }, '', url); } catch (e) { location.assign(url); return; } }
    var sel = sortForm && sortForm.querySelector('select'); if (sel && sel.value !== (value || def)) sel.value = value || def;
    if (isPriceSort(value)) { enterSorted(value, false); return; }
    /* the collection's own order (or another server sort): its first page, swapped in */
    reset('server'); var tok = st.token;
    st.loading = true; st.ctrl = window.AbortController ? new AbortController() : null;
    grid.classList.add('tnf-browse-sorting'); setStatus('loading', 'Updating…');
    fetch(url, { credentials: 'same-origin', signal: st.ctrl ? st.ctrl.signal : undefined, headers: { 'X-Requested-With': 'tnf-browse' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        if (tok !== st.token) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ng = doc.getElementById('CollectionProductGrid'); var nl = ng && ng.querySelector('.productListing');
        if (!nl) throw new Error('no grid in the response');
        list.innerHTML = ''; st.seen = {};
        var added = append(cards(nl).map(function (li) { return document.adoptNode(li); }));
        cards().forEach(function (li) { li.removeAttribute('data-tnf-loaded'); });
        var np = ng.querySelector('.pagination-wrapper'), cp = $('.pagination-wrapper');
        if (np && cp) cp.replaceWith(document.adoptNode(np)); else if (np && !cp) list.parentNode.appendChild(document.adoptNode(np));
        st.loading = false; grid.classList.remove('tnf-browse-sorting');
        var m = meta(); st.total = m ? (parseInt(m.getAttribute('data-total'), 10) || added) : added;
        st.initial = cards().length; mount(); readNext(); afterAppend(added); announce(); save();
        if (!st.done) setTimeout(check, 50);
      })
      .catch(function (err) {
        if (tok !== st.token || (err && err.name === 'AbortError')) return;
        location.assign(url);                                  /* could not swap in place: load the page itself */
      });
  }
  if (sortForm) {
    var sel = sortForm.querySelector('select');
    if (sel) sel.addEventListener('change', function () { applySort(sel.value, true); });
    sortForm.addEventListener('submit', function (e) { e.preventDefault(); applySort(sel ? sel.value : '', true); });
    window.addEventListener('popstate', function () {
      if (keyNow() === st.key) return;
      var v = sortNow(); applySort(v, false);
    });
  }

  /* ---- Back / Forward: keep what was loaded and where the customer was ----
     The saved copy is keyed by the address (path + sort + filters). With the cards kept, they are put
     back as they were; without them (no storage, or over the limit), the same batches are loaded again
     in order, and the scroll position is restored once they are on the page. */
  function save() {
    try {
      var payload = { t: Date.now(), mode: st.mode, dir: st.dir, pages: st.pages, count: st.count, y: window.scrollY, done: st.done, html: null, pag: null, items: null };
      if (st.mode === 'sorted') {
        payload.items = st.items;
        var all = cards().map(function (li) { return li.outerHTML; }).join('');
        if (all.length < STORE_MAX) payload.html = all;
      } else if (st.pages > 1) {
        var extra = cards().filter(function (li) { return li.hasAttribute('data-tnf-loaded'); }).map(function (li) { return li.outerHTML; }).join('');
        if (extra.length < STORE_MAX) { payload.html = extra; payload.pag = ($('.pagination') || {}).outerHTML || null; }
      }
      /* the place itself (order, how far, where) also rides on this history entry, so Back can restore it even
         when the browser keeps no session storage at all */
      try { history.replaceState(Object.assign({}, history.state || {}, { tnfBrowse: { key: st.key, t: payload.t, mode: payload.mode, dir: payload.dir, pages: payload.pages, count: payload.count, y: payload.y } }), ''); } catch (e) {}
      /* too big for the storage left: first without the cards (the batches are loaded again), then without the
         sorted list as well (the price index is read again) - the place is always kept */
      var tries = [payload, Object.assign({}, payload, { html: null, pag: null }), Object.assign({}, payload, { html: null, pag: null, items: null })];
      for (var i = 0; i < tries.length; i++) { try { sessionStorage.setItem(st.key, JSON.stringify(tries[i])); break; } catch (quota) {} }
    } catch (e) {}
  }
  function scrollBack(y) {
    if (!(y > 0)) return;
    try { history.scrollRestoration = 'manual'; } catch (e) {}
    var go = function () { window.scrollTo(0, y); };
    go(); requestAnimationFrame(go); setTimeout(go, 250); setTimeout(go, 700);
  }
  /* load batches until `want` is reached (pages in the collection's order, cards in the price order) */
  function replay(want, y) {
    var tok = st.token;
    setStatus('loading', 'Restoring your place…');
    (function step() {
      if (tok !== st.token) return;
      var have = st.mode === 'sorted' ? st.count : st.pages;
      if (st.done || have >= want) { announce(); scrollBack(y); return; }
      nextBatch(true).then(function (ok) { if (ok) step(); /* on failure the Retry button is already offered */ });
    })();
  }
  function restore() {
    var raw = null; try { raw = sessionStorage.getItem(st.key); } catch (e) {}
    var s = null; if (raw) { try { s = JSON.parse(raw); } catch (e) { s = null; } }
    if (!s) { var hs = history.state && history.state.tnfBrowse; if (hs && hs.key === st.key) s = hs; }   /* no storage: the history entry's copy */
    if (!s || Date.now() - s.t > STORE_TTL) return false;
    if (s.mode === 'sorted' && isPriceSort(sortNow())) {
      enterSorted(sortNow(), true, s).then(function (how) {
        if (how === 'restored') scrollBack(s.y);
        else if (how === 'sorted') replay(s.count || st.per, s.y);
      });
      return true;
    }
    if (!(s.pages > 1)) return false;
    if (s.html) {
      var tmp = document.createElement('ul'); tmp.innerHTML = s.html;
      var added = append(Array.prototype.slice.call(tmp.children));
      var cp = $('.pagination'); if (s.pag && cp) { var d = document.createElement('div'); d.innerHTML = s.pag; if (d.firstElementChild) cp.replaceWith(d.firstElementChild); }
      st.pages = s.pages; mount(); readNext(); afterAppend(added); announce();
      scrollBack(s.y); return true;
    }
    replay(s.pages, s.y);                                   /* no copy kept: the same pages again, then the place */
    return true;
  }
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;                               /* bfcache: the page is exactly as it was left */
    if (st.loading && !st.ctrl) st.loading = false;
    mount(); if (st.mode === 'server') readNext(); announce(); setTimeout(check, 100);
  });
  window.addEventListener('pagehide', save);
  document.addEventListener('click', function (e) { var a = e.target && e.target.closest && e.target.closest('a[href*="/products/"]'); if (a && list.contains(a)) save(); }, true);

  /* ---- start ------------------------------------------------------------ */
  reset('server');
  announce();
  var restored = false;
  try { restored = restore(); } catch (e) { restored = false; }
  if (!restored) {
    try { sessionStorage.removeItem(st.key); } catch (e) {}
    if (isPriceSort(sortNow())) enterSorted(sortNow(), false);
  }
  if (!window.IntersectionObserver) window.addEventListener('scroll', function () { check(); }, { passive: true });
  window.addEventListener('scroll', function () { if (!st.loading && !st.done && !st.failed) { var r = sentinel.getBoundingClientRect(); if (r.top < (window.innerHeight || 800) * 1.5) nextBatch(false); } }, { passive: true });
  window.__tnfBrowse = function () {
    return { mode: st.mode, dir: st.dir, next: st.next, done: st.done, loading: st.loading, pages: st.pages, count: st.count, shown: shown(), total: st.total,
             failed: st.failed, seen: Object.keys(st.seen).length, token: st.token, key: st.key, items: st.items ? st.items.length : null };
  };
  window.__tnfBrowseApplySort = function (v) { applySort(v, true); };     /* read-only test hook: the same path as the control */
})();
